import { useState } from "react";
import { Lock, ArrowLeft, Eye, EyeSlash, TickCircle } from "iconsax-reactjs";

export default function ForgotPasswordScreen() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Password validation
  const hasMinLength = password.length >= 8;
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const handleSubmit = async () => {
    if (
      !password.trim() ||
      !confirmPassword.trim() ||
      password !== confirmPassword
    )
      return;

    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // Handle password reset logic here
      console.log("Password reset completed");
    }, 1500);
  };

  const handleBackToLogin = () => {
    // Navigate back to login - replace with your routing logic
    console.log("Navigate back to login");
  };

  return (
    <div className="auth-page">
      <img src="/assets/clockout-lockup-hero-2400.png" alt="Clock-out" className="auth-logo" />

      <div className="auth-card">
        {/* Icon */}
        <div className="flex justify-center mb-5">
          <div className="w-14 h-14 bg-[#FFC81E] rounded-[16px] flex items-center justify-center">
            <Lock className="w-7 h-7 text-[#1C1A14]" />
          </div>
        </div>

        {/* Main Content */}
        <div className="text-center mb-7">
          <h1 className="auth-title">Set new password</h1>
          <p className="auth-subtitle">
            Your new password must be different to previously used passwords.
          </p>
        </div>

        {/* Form */}
        <div className="space-y-5">
          <div>
            <label htmlFor="password" className="auth-label">
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="auth-input pr-12"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#857A63] hover:text-[#1C1A14] transition-colors"
              >
                {showPassword ? (
                  <EyeSlash className="w-5 h-5" />
                ) : (
                  <Eye className="w-5 h-5" />
                )}
              </button>
            </div>
          </div>

          {/* Confirm Password Input */}
          <div>
            <label htmlFor="confirmPassword" className="auth-label">
              Confirm password
            </label>
            <div className="relative">
              <input
                id="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                className="auth-input pr-12"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#857A63] hover:text-[#1C1A14] transition-colors"
              >
                {showConfirmPassword ? (
                  <EyeSlash className="w-5 h-5" />
                ) : (
                  <Eye className="w-5 h-5" />
                )}
              </button>
            </div>
          </div>

          {/* Password Requirements */}
          <div className="space-y-2 py-1">
            <div className="flex items-center gap-2">
              <div
                className={`w-4 h-4 rounded-full flex items-center justify-center ${
                  hasMinLength ? "bg-[#1C1A14]" : "bg-[#E3D6B6]"
                }`}
              >
                {hasMinLength && <TickCircle className="w-3 h-3 text-[#FFC81E]" />}
              </div>
              <span className={`text-sm ${hasMinLength ? "text-[#1C1A14]" : "text-[#857A63]"}`}>
                Must be at least 8 characters
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div
                className={`w-4 h-4 rounded-full flex items-center justify-center ${
                  hasSpecialChar ? "bg-[#1C1A14]" : "bg-[#E3D6B6]"
                }`}
              >
                {hasSpecialChar && <TickCircle className="w-3 h-3 text-[#FFC81E]" />}
              </div>
              <span className={`text-sm ${hasSpecialChar ? "text-[#1C1A14]" : "text-[#857A63]"}`}>
                Must contain one special character
              </span>
            </div>
          </div>

          <button onClick={handleSubmit} disabled={isLoading} className="auth-btn-primary">
            {isLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-[#1C1A14] border-t-transparent rounded-full animate-spin"></div>
                Sending…
              </>
            ) : (
              "Reset password"
            )}
          </button>
        </div>

        <hr className="auth-divider" />
        <button
          onClick={handleBackToLogin}
          className="w-full text-sm text-[#4A4234] hover:text-[#1C1A14] font-semibold transition-colors flex items-center justify-center group"
        >
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
          Back to sign in
        </button>
      </div>

      <p className="auth-footer">© {new Date().getFullYear()} Talk Nerdy To Me Consultancy Ltd. All rights reserved.</p>
    </div>
  );
}